import { Link, Stack } from 'expo-router';
import { FileUpIcon } from 'lucide-react-native';
import { ScrollView, View } from 'react-native';

import { Button } from '@sixam/ui/button';
import { Icon } from '@sixam/ui/icon';
import { Text } from '@sixam/ui/text';

const devices = [
  ['Garmin', 'Export the course as a GPX file from Garmin Connect on the web.'],
  ['COROS', 'Open the route in the COROS app, use Export, and choose GPX.'],
  ['Suunto', 'Open the route options in the Suunto app and export the GPX file.'],
  ['Plotaroute', 'Open Download, choose GPX, and keep the track-point option enabled.'],
] as const;

export default function RouteImportGuideScreen() {
  return (
    <ScrollView
      className="flex-1 bg-background"
      contentContainerClassName="mx-auto w-full max-w-3xl gap-6 p-5 pb-28"
      contentInsetAdjustmentBehavior="automatic"
    >
      <Stack.Screen options={{ headerShown: true, title: 'Import a route' }} />
      <View className="gap-2">
        <Text variant="label" className="text-muted-foreground">
          GPX guide
        </Text>
        <Text variant="h1">Bring your route with you</Text>
        <Text variant="muted">
          Routes from watches and planning tools can live beside routes made in 6am. Export a GPX,
          then import it into your club library.
        </Text>
      </View>

      <View className="border-t border-border">
        {devices.map(([name, detail]) => (
          <View key={name} className="gap-1 border-b border-border py-4">
            <Text variant="large">{name}</Text>
            <Text variant="muted">{detail}</Text>
          </View>
        ))}
      </View>

      <View className="gap-2 border-y border-border py-4">
        <Text className="font-bold">In 6am</Text>
        <Text variant="muted">
          Open Routes, choose the right club, then tap Import GPX. Preview the trace, name it, and
          save.
        </Text>
      </View>

      <Link href="/app/routes" asChild>
        <Button>
          <Icon as={FileUpIcon} className="size-4 text-primary-foreground" />
          <Text>Open route library</Text>
        </Button>
      </Link>
    </ScrollView>
  );
}
